import React, { Fragment } from 'react';
import TitleServices from '../TitleServices/TitleServices';
import CardIconInfo from '../CardIconInfo/CardIconInfo';

function WhyUs() {
  return (
    <Fragment>
      <div className='lg:w-6/12 w-full'>
        <TitleServices
          showBtn={false}
          description='خطة سير العمل'
          secondDescription='تهدف شركة GE Step للتسويق الالكتروني للمؤسسات والاشخاص والشركات وذلك طبق أليات وخطط موضوعة مسبقا بهدف اشهار علامتك التجارية.'
        />

        <CardIconInfo
          description='الاستلام'
          secondDescription='يبدأ الأمر بعمل أجتماع زوم مع عملائنا لنفهم طبيعة النشاط والعمل ومتطلباته، ما هي الأهداف التي يريد أن يتوصل إليها، ومعرفة تصوراتهم عن أعمالهم.'
          AiOutlineFullscreenIcon
        />

        <CardIconInfo
          description='الدراسة والبحث'
          secondDescription='يتم دراسة المشروع والسوق المتواجد به، والبحث في المشروعات المنافسة وأهم الاستراتيجيات التي يستخدمها المنافسين ونقاط قوتهم وضعفهم وكيف يتم استغلالها، ودراسة العملاء المستهدفين، وصفاتهم واحتياجاتهم.'
          AiOutlineCodeIcon
        />

        <CardIconInfo
          description='وضع الخطط والأهداف'
          secondDescription='بناء على الدراسة والبحث السابق يتم وضع الخطط الاستراتيجية وتحدد المنصات التسويقية التي سيتم التواصل مع الجمهور من خلالها. وأيضًا تحديد الأهداف التسويقية والمؤشرات التي تقيس تحقيق هذه الأهداف.'
          AiOutlineFileProtectIcon
        />
        <CardIconInfo
          description='التنفيذ'
          secondDescription='يبدأ فريق عملنا بالتعاون والعمل باحترافية على تنفيذ الخطة الاستراتيجية الموضوعة، لتحقيق التواجد القوي والفعال من خلال منصات السوشيال ميديا ومحركات البحث.'
          AiOutlineAntDesignIcon
        />
        <CardIconInfo
          description='قياس نتائج الأداء'
          secondDescription='بناء على مؤشرات الأداء الموضوعة يتم قياس نتائج الأداء المبذول، للتأكد من تحقيق الاستهداف الصحيح وظهور العملاء الباحثون عن خدماتك أو الحاجة للتطوير والتحسين ومن ثم استخراج هذه التقارير لأصحاب المشروعات.'
          AiOutlineSafetyIcon
        />
      </div>

      <div className='md:h-110 h-72 lg:w-6/12 md:w-10/12 m-auto w-full moveSVG flex'>
        <img
          src='https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/Data%20report-pana.svg?alt=media&token=7fc48cbf-39e4-4270-8746-ee215e9bb2c5'
          alt='imagehere'
          className='h-full w-full'
        />
      </div>
    </Fragment>
  );
}

export default WhyUs;
